"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Date is an interface so type information won't be available at runtime.
 * We need type information in classes processed by JsonParser
 */
class DateClass extends Date {
}
DateClass.type = "DateClass";
exports.DateClass = DateClass;
